<template>
    <views v-if="!wxCode" class="login">
        <nav-bar
            v-if="!bindWxMobile"
            absolute
            theme="white"
            @click-left="onClickLeft">
        </nav-bar>
        <views class="banner">
            <images :src="banner"></images>
        </views>
        <views class="form">
            <views class="form-label">手机号</views>
            <views class="form-text">
                <input type="number" pattern="[0-9]*" placeholder="请输入您的手机号" v-model="form.mobile">
            </views>
            <views class="form-label mt36">验证码</views>
            <views class="sms-code">
                <views class="sms-code-left">
                    <views class="form-text">
                        <input type="number" pattern="[0-9]*" placeholder="请输入验证码" v-model="form.smsCode">
                    </views>
                </views>
                <views class="sms-code-right">
                    <button
                        :disabled="sendTime > 0"
                        @click="sendSmsCode">{{ sendTitle }}
                    </button>
                </views>
            </views>
            <views class="form-button mt144">
                <button :disabled="doing" @click="handleLogin">绑定手机号</button>
            </views>
            <views
                v-if="!bindWxMobile"
                class="form-button primary mt40">
                <button :disabled="doing" @click="handleWx">微信登录</button>
            </views>
            <views
                v-if="!bindWxMobile"
                class="form-des mt40">
                *温馨提示：未注册中阿化肥账号的手机号，登录时将自动注册，且代表您已同意
                <views class="agreement-info" @click="handleShowModal">《用户注册协议》</views>
            </views>
            <agreement-modal v-model="showModal" :html="agreementInfo"></agreement-modal>
        </views>
    </views>
</template>

<script>
import AgreementModal from './AgreementModal'
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
import storage from '@/utils/storage'
import api from '@/utils/api'
import axios from 'axios'
import {
    wxAppId,
    wxRedirectUri
} from '@/utils/url-config'

export default {
    name: 'Login',
    components: {
        NavBar,
        AgreementModal
    },
    mixins: [tools],
    data() {
        return {
            doing: false,
            showModal: false,
            agreementInfo: '', // 用户注册协议
            banner: require('@/assets/images/login_banner.jpg'),
            form: {
                mobile: '',
                smsCode: ''
            },
            smsCodeTitle: '',
            sendTime: 0,
            codeTimer: null,
            greementInfo: ''
        }
    },
    computed: {
        query() {
            return this.$route.query
        },
        wxCode() {
            return this.query.code
        },
        bindWxMobile() {
            return this.$route.query.type === 'wx'
        },
        sendTitle() {
            return this.sendTime > 0 ? `${this.smsCodeTitle}(${this.sendTime})` : '获取验证码'
        }
    },
    watch: {
        wxCode: {
            handler(val) {
                console.log(val)
                if (val) this.loginWx(val)
            },
            immediate: true
        }
    },
    created() {
        // this.getAgreementInfo()
    },
    destroyed() {
        clearInterval(this.codeTimer)
    },
    methods: {
        onClickLeft() {
            this.replace('/')
        },
        // 手机号登陆/新用户绑定手机号
        handleLogin() {
            const { mobile, smsCode } = this.form
            if (!mobile) return this.notify('请输入手机号码')
            if (mobile.length > 11) return this.notify('手机号码超过11位')
            const re = /^1\d{10}$/
            if (!re.test(mobile)) return this.notify('请输入正确的手机号码')
            if (!smsCode) return this.notify('请输入验证码')
            if (!(smsCode.length === 6)) return this.notify('请输入正确的验证码')
            const params = {
                phone:mobile,
                sms_code: smsCode
            }
            this.doing = true
            if (this.bindWxMobile) {
                api.updateUserInfo(params).then((res) => {
                    if (res.err_code === 1002) {
                        this.notify('验证码错误')
                        this.doing = false
                    } else {
                        if (res.user_type) storage.set('userType', res.user_type)
                        // if (res.access_token) storage.set('accessToken', res.access_token)
                        if (res.access_token) this.setCookie('accessToken', res.access_token)
                        this.sucMsg('绑定手机号码成功')
                        this.windowReplace(window.location.origin)
                    }
                }).catch(() => {
                    this.doing = false
                })
            } else {
                api.login(params).then((res) => {
                    console.log('登陆res', res)
                    this.commonAction(res.data)
                    this.doing = false
                }).catch(() => {
                    this.doing = false
                })
            }
        },
        // 微信登录
        loginWx(code) {
            this.doing = true
            api.loginWx({ code }).then((res) => {
                console.log('登陆res', res)
                this.commonAction(res.data)
                this.doing = false
            }).catch(() => {
                this.doing = false
            })
        },
        commonAction(data) {
            storage.set('test', JSON.stringify(data)) // 登陆获取token请求返回
            storage.set('accessExpire', data.expireAt)
            // storage.set('accessToken', data.token)
            this.setCookie('accessToken', data.token)
            storage.set('userType', data.user_type)
            // 新用户绑定手机号码
            if (data.is_new_user) {
                this.windowReplace(`${window.location.origin}/login?type=wx`)
            } else {
                this.windowReplace(storage.get('loginAfterUrl'))
            }
        },
        setCookie(name,value,time){
            let hours = time?time:1920;  //单位小时
            let exp = new Date();
            exp.setTime(exp.getTime() + hours*60*60*1000);
            document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString() + ";path=/";

        },
        sendSmsCode() {
            const { mobile } = this.form
            if (!mobile) return this.notify('请输入手机号码')
            if (mobile.length > 11) return this.notify('手机号码超已过11位')
            const re = /^1\d{10}$/
            if (!re.test(mobile)) return this.notify('请输入正确的手机号码')
            const params = { phone:mobile }
            api.sendSms(params).then((res) => {
                if (res.code === 0) {
                    this.sucMsg('验证码已发送')
                    this.getSmsCodeTitle()
                } else {
                    this.notify(res.err_msg)
                }
            })
        },
        getSmsCodeTitle() {
            clearInterval(this.codeTimer)
            this.sendTime = 60
            this.smsCodeTitle = '已发送'
            this.codeTimer = setInterval(() => {
                this.sendTime--
            }, 1000)
        },
        handleWx() {
            // const params = {
            //     url: window.location.href
            // }
            // api.getWxSdkInfo(params).then(res=>{
            //     wx.ready(function(){
            //         // 调用微信JS api 执行登录
            //         wx.login({
            //             success: function(res) {
            //             if (res.code) {
            //                 // 发起网络请求
            //                 axios('https://api.junong360.com/farmer/login_wx', {
            //                     method: 'POST',
            //                     headers: {
            //                         'content-type': 'application/json'
            //                     },
            //                     body: JSON.stringify({
            //                         code: res.code // 发送到后端进行登录
            //                     })
            //                 }).then(response => {
            //                     return response.json();
            //                 }).then(data => {
            //                     // 登录成功后的逻辑
            //                 });
            //             }
            //             }
            //         });
            //     });
            // })
            
            // 微信授权 - 获取code
            this.windowReplace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxAppId}&redirect_uri=${wxRedirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`)
        },
        handleShowModal() {
            this.showModal = true
        },
        getAgreementInfo() {
            api.getAgreementInfo().then((res) => {
                if (res.data && res.data.agreement_content) {
                    this.agreementInfo = res.data.agreement_content
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
